import { all, fork } from 'redux-saga/effects'
import getRecentSaga from './getRecentSaga'
import getStoriesSaga from './getStoriesSaga'
import getReactionSaga from './getReactionSaga'

export default function* feedSaga(params) {
  yield all([fork(getRecentSaga), fork(getStoriesSaga, params), fork(getReactionSaga, params)])
}
